import React, { Fragment, useEffect, useState } from 'react';
import { useParams } from 'react-router-dom'
import { connect } from "react-redux";
import Navbar from '../../components/Navbar/Navbar'
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import Footer from '../../components/footer/Footer';
import { addToCart } from "../../store/actions/action";
import Product from './product'
import api from "../../api";
import ProductTabs from './alltab';



const ProductSinglePage = (props) => {
    const { slug } = useParams()

    const addToCartProduct = (product, qty = 1) => {
        addToCart(product, qty);
    };

    const { addToCart } = props;
    const [product, setProduct] = useState({});
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchProduct = async () => {
            try {
                setLoading(true);
                const productsArray = await api();
                const filteredProduct = productsArray.filter(product => product.slug === String(slug));
                setProduct(filteredProduct[0] || {});
            } catch (error) {
                console.error('Error fetching product:', error);
                setProduct({});
            } finally {
                setLoading(false);
            }
        };

        fetchProduct();
    }, [slug]);

    return (
        <Fragment>
            <Navbar hclass={'wpo-header-style-3'}/>
            <PageTitle pageTitle={'Product Single'} pagesub={'Product Single'} />
            <section className="wpo-shop-single-section section-padding">
                <div className="container">
                    {loading ? (
                        <div style={{ textAlign: 'center', padding: '50px' }}>
                            <p>Loading product...</p>
                        </div>
                    ) : (
                        product && Object.keys(product).length > 0 ? (
                            <Product
                                item={product}
                                addToCart={addToCartProduct}
                            />
                        ) : (
                            <div style={{ textAlign: 'center', padding: '50px' }}>
                                <p>Product not found</p>
                            </div>
                        )
                    )}
                    <ProductTabs />
                </div>
            </section>
            <Footer footerClass={'wpo-site-footer-s2'}/>
            <Scrollbar />
        </Fragment>
    )
};

const mapStateToProps = state => {
    return {
        products: state.data.products,
    }
};

export default connect(mapStateToProps, { addToCart })(ProductSinglePage);
